import React, { ReactNode } from 'react';

export interface IMemberIdFormatterProps {
  id: string;
}

export const memberIdFormatter = ({ id }: IMemberIdFormatterProps): ReactNode => (
  <span>{id.slice(0, 8)}</span>
);
